module.exports = __webpack_public_path__ + "img/744.43573fd0.jpg";